/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Kpi_Total_SkusInputs */

const vi_warehouse_sales_kpi_total_skus = /** @type {(inputs: Warehouse_Sales_Kpi_Total_SkusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số SKU`)
};

/**

* @param {Warehouse_Sales_Kpi_Total_SkusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_kpi_total_skus = /** @type {((inputs?: Warehouse_Sales_Kpi_Total_SkusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Kpi_Total_SkusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_kpi_total_skus(inputs)
});